import { Box, useColorModeValue } from "@chakra-ui/react";
import { Feature } from "geojson";
import { useEffect, useMemo, useRef, useState } from "react";
import ReactMapGl, { Layer, LngLatBounds, MapRef, Source, useMap } from "react-map-gl";

function MiniMap() {
  const miniMapRef = useRef<MapRef>(null);
  const parentMap = useMap();
  const [ bounds, setBounds ] = useState<LngLatBounds>();

  const mapStyle = useColorModeValue(
    "mapbox://styles/devseed/clz7artka03eh01p9518wgnpy",
    "mapbox://styles/devseed/clz35cbi302l701qo2snhdx9x"
  );

  useEffect(() => {
    const mapRef = parentMap.current;
    const handleBboxChange = () => {
      const zoom = mapRef?.getZoom();
      const center = mapRef?.getCenter();
      setBounds(mapRef?.getBounds());

      (zoom && center) && miniMapRef.current?.jumpTo({
        zoom: zoom - 6 > 0 ? zoom - 6 : 0,
        center
      }, {
        duration: 0
      });
    };

    mapRef?.on("move", handleBboxChange);

    return () => {
      mapRef?.off("move", handleBboxChange);
    };
  }, [parentMap]);

  const boundsFeature: Feature | undefined = useMemo(() => {
    if (!bounds) return;
    return {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            bounds.getNorthEast().toArray(),
            bounds.getSouthEast().toArray(),
            bounds.getSouthWest().toArray(),
            bounds.getNorthWest().toArray(),
            bounds.getNorthEast().toArray(),
          ]
        ]
      },
      properties: {}
    };
  }, [bounds]);

  return (
    <Box w="150px" h="100px" position="absolute" left="4" top="4" zIndex="1000" border="1px solid" borderRadius="sm">
      <ReactMapGl
        ref={miniMapRef}
        mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
        initialViewState={{
          longitude: -122.355,
          latitude: 37.828,
          zoom: 3,
        }}
        mapStyle={mapStyle}
        projection={{
          name: "mercator",
        }}
        attributionControl={false}
      >
        <Source id="bounds-geom-source" type="geojson" data={boundsFeature}>
          <Layer id="bounds-geom-outline" type="line" paint={{"line-color": "#1ed0f2", "line-width": 1}} />
        </Source>
      </ReactMapGl>
    </Box>
  );
}

export default MiniMap;
